import { requireNotNull } from "@whilecat/core/utils/validation.js";

export function getCSSVariable(variable: string) {
    return getComputedStyle(document.documentElement).getPropertyValue(variable);
}

export function getCSSVariablePixels(variable: string) {
    return Number(getCSSVariable(variable).replace("px", ""));
}

export function scrollToElement(element: HTMLElement, offsetFromTop: number) {
    requireNotNull(element);

    const elementRect = element.getBoundingClientRect();
    const elementTop = elementRect.top + window.scrollY;

    window.scrollTo({
        top: elementTop - offsetFromTop,
        behavior: "smooth",
    });
}

export function scrollToView(element: HTMLElement, strategy: ScrollLogicalPosition = "start") {
    requireNotNull(element);
    element.scrollIntoView({ behavior: "smooth", block: strategy, inline: "nearest" });
}

export function isMobile() {
    return typeof window !== "undefined" && window.screen.width <= 1200;
}

export function setupMobileHidingListenerY(element: HTMLElement, className: string) {
    requireNotNull(element);
    requireNotNull(className);

    let lastScrollTop = 0;
    let scrollDelta = 0;
    const jitterThreshold = 70; // pixels to scroll up before showing again

    window.addEventListener("scroll", () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        const delta = scrollTop - lastScrollTop;

        if (delta > 0) {
            // scrolling down → hide immediately
            element.classList.add(className);
            scrollDelta = 0; // reset accumulated scroll-up distance
        } else if (delta < 0) {
            // scrolling up → accumulate distance
            scrollDelta += Math.abs(delta);
            if (scrollDelta >= jitterThreshold) {
                element.classList.remove(className);
            }
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });
}
